import { render, staticRenderFns } from "./CreateProjectAppealText.vue?vue&type=template&id=3a5e6edc&scoped=true&"
import script from "./CreateProjectAppealText.vue?vue&type=script&lang=js&"
export * from "./CreateProjectAppealText.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectAppealText.vue?vue&type=style&index=0&id=3a5e6edc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e6edc",
  null
  
)

export default component.exports